import { useLocation, useNavigate } from 'react-router-dom';
import WorkReports from './WorkReports';
import { uploadShowcaseFile } from '../api/fileApi';
const uploadReportFile = (file: File) => uploadShowcaseFile(file, file.type.startsWith('image/') ? 'image' : 'document');
import { apiFetch } from '../auth/runtimeAuth';
import { API_BASE_URL, getShowcaseBlockIdFromUrl } from '../api/showcaseApi';
export const reportsApi = async (path: string, options?: RequestInit) => {
  const response = await apiFetch(`${API_BASE_URL}/showcase${path}`, options);
  const body = await response.json();
  if (!response.ok) throw new Error(typeof body.detail === 'string' ? body.detail : 'Не удалось выполнить действие');
  return body;
};
export default function ReportsPage({ archive = false, role }: { archive?: boolean; role: 'manager' | 'specialist' }) {
  const navigate = useNavigate(); const { search } = useLocation();
  return <WorkReports key={archive ? 'archive' : 'active'} uploadFile={uploadReportFile} api={reportsApi} blockId={getShowcaseBlockIdFromUrl()} archive={archive} initialReportId={new URLSearchParams(search).get('report') || undefined} initialOrderId={archive ? undefined : new URLSearchParams(search).get('order') || undefined}
    onBack={() => navigate({ pathname: archive ? `/${role}/reports` : `/${role}`, search })}
    onArchive={() => navigate({ pathname: `/${role}/reports/archive`, search })}
    onPayments={id => navigate({ pathname: '/manager/orders', search: `${search}${search ? '&' : '?'}order=${id}` })} />;
}
